// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Colors */
  --primary: #2563eb;
  --primary-dark: #1d4ed8;
  --secondary: #0f172a;
  --success: #10b981;
  --danger: #ef4444;

  --background: #eef3fb;
  --surface: #ffffff;
  --surface-light: #f8fafc;

  --text: #1e293b;
  --text-light: #64748b;

  --border: #dbe4f0;

  --white-principale: #fff;

  --brand-live: #16c79a;
  --brand-accent-warm: #ff9f1c;
  --sidebar-width: 264px;

  /* Neutres partagés (cartes, tableaux, bordures) */
  --color-border: #e8e8e8;
  --color-border-soft: #f0f0f0;
  --color-surface: #fafafa;
  --color-surface-alt: #f4f4f4;
  --color-ink: #222;
  --color-ink-soft: #666;
  --color-ink-faint: #999;
  --color-ink-mute: #aaa;

  /* Surfaces immersives sombres (login, écrans plein écran) */
  --color-bg-deep: #0a1220;
  --color-bg-mid: #0f2036;
  --color-bg-high: #17324e;
  --color-line-onhome: rgba(255, 255, 255, 0.08);
  --color-text-invert: #eef2f7;
  --color-text-invert-soft: #97a6bb;
  --glass-bg: rgba(19, 36, 65, 0.55);
  --glass-border: rgba(255, 255, 255, 0.09);

  /* Typographie */
  --font-display: "Space Grotesk", "Segoe UI", sans-serif;
  --font-body: "Manrope", "Segoe UI", sans-serif;
  --font-mono: "JetBrains Mono", "Courier New", monospace;
}

body {
  font-family: var(--font-family);
  background: var(--background);
  color: var(--text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  text-decoration: none;
}

img {
  max-width: 100%;
}

input,
button {
  font-family: inherit;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;;EAEjB,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;;EAExB,eAAe;EACf,qBAAqB;;EAErB,iBAAiB;;EAEjB,wBAAwB;;EAExB,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;;EAEtB,kDAAkD;EAClD,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,4BAA4B;EAC5B,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;;EAEtB,4DAA4D;EAC5D,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,8CAA8C;EAC9C,4BAA4B;EAC5B,iCAAiC;EACjC,kCAAkC;EAClC,yCAAyC;;EAEzC,gBAAgB;EAChB,uDAAuD;EACvD,8CAA8C;EAC9C,uDAAuD;AACzD;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;AACtB","sourcesContent":[":root {\n  /* Colors */\n  --primary: #2563eb;\n  --primary-dark: #1d4ed8;\n  --secondary: #0f172a;\n  --success: #10b981;\n  --danger: #ef4444;\n\n  --background: #eef3fb;\n  --surface: #ffffff;\n  --surface-light: #f8fafc;\n\n  --text: #1e293b;\n  --text-light: #64748b;\n\n  --border: #dbe4f0;\n\n  --white-principale: #fff;\n\n  --brand-live: #16c79a;\n  --brand-accent-warm: #ff9f1c;\n  --sidebar-width: 264px;\n\n  /* Neutres partagés (cartes, tableaux, bordures) */\n  --color-border: #e8e8e8;\n  --color-border-soft: #f0f0f0;\n  --color-surface: #fafafa;\n  --color-surface-alt: #f4f4f4;\n  --color-ink: #222;\n  --color-ink-soft: #666;\n  --color-ink-faint: #999;\n  --color-ink-mute: #aaa;\n\n  /* Surfaces immersives sombres (login, écrans plein écran) */\n  --color-bg-deep: #0a1220;\n  --color-bg-mid: #0f2036;\n  --color-bg-high: #17324e;\n  --color-line-onhome: rgba(255, 255, 255, 0.08);\n  --color-text-invert: #eef2f7;\n  --color-text-invert-soft: #97a6bb;\n  --glass-bg: rgba(19, 36, 65, 0.55);\n  --glass-border: rgba(255, 255, 255, 0.09);\n\n  /* Typographie */\n  --font-display: \"Space Grotesk\", \"Segoe UI\", sans-serif;\n  --font-body: \"Manrope\", \"Segoe UI\", sans-serif;\n  --font-mono: \"JetBrains Mono\", \"Courier New\", monospace;\n}\n\nbody {\n  font-family: var(--font-family);\n  background: var(--background);\n  color: var(--text);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\na {\n  text-decoration: none;\n}\n\nimg {\n  max-width: 100%;\n}\n\ninput,\nbutton {\n  font-family: inherit;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
